import { createFileRoute } from '@tanstack/react-router';

import { ensureMediaQueryData } from '@/api/media';

export const Route = createFileRoute(
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/'
)({
  loader: ensureMediaQueryData,
});
